export class EntCompanyFilter {
  page: number = 1;
  size: number = 30;
  companyName: string | null = null;
  deleted: boolean = false;
}